import { supabase } from '@/lib/supabase'

export type CadastroWebhookPayload = {
  nome_completo: string
  numero_telefone: string
}

export function shouldSendCadastroWebhook(params: URLSearchParams): boolean {
  const plan = (params.get('plan') || '').trim().toLowerCase()
  return plan === 'trial_7d'
}

export function buildCadastroWebhookPayload(name: string, phone: string): CadastroWebhookPayload {
  return {
    nome_completo: (name || '').trim(),
    numero_telefone: (phone || '').trim(),
  }
}

export async function sendCadastroWebhook(payload: CadastroWebhookPayload) {
  return supabase.functions.invoke('send-cadastro-webhook', { body: payload })
}
